module.exports = __webpack_public_path__ + "static/media/module-cast.9b9b38b6.png";